<template>
  <page>
    <component :is="currentType" />
  </page>
</template>

<script>
import ByOs from './component/ByOs.vue'

export default {
  data() {
    return {
      currentType: 'ByOs',
      params: {
        model: '',
        groupId: ''
      },

      serviceList: [],
      groupList: [],
      appList: []
    }
  },
  created() {},
  components: {
    ByOs
  },
  methods: {
    async getData() {}
  }
}
</script>

<style lang="scss" scoped>
.timeFrame,
.picker-wrap {
  display: flex;
  align-items: center;
}
</style>
